export { area } from './area';
export { bottom } from './bottom';
export { bottomLeft } from './bottomLeft';
export { bottomRight } from './bottomRight';
export { inside } from './inside';
export { left } from './left';
export { outside } from './outside';
export { right } from './right';
export { spider } from './spider';
export { surround } from './surround';
export { top } from './top';
export { topLeft } from './topLeft';
export { topRight } from './topRight';
//# sourceMappingURL=index.js.map